import '@babel/polyfill';
import './globals';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from "@sentry/tracing";
import { createBrowserHistory as createHistory } from 'history';
import ReactGA from 'react-ga';
import PlatformApp from './platform-app';
import { gaTrackerInitialize } from './shared/utils/analyticsTracker';
import configureStore from './configureStore';
import initialState from './initialState';
import Routes from './domain/router/routes.constants';
import NetworkService from './shared/NetworkService';

if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line import/no-extraneous-dependencies,global-require
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}


const history = createHistory();
NetworkService.init(history);

const store = configureStore(initialState, history);

const ignoreRoutesList = [
    Routes.MANAGE,
    Routes.OVERVIEW,
];

history.listen((location) => {
    if (!ignoreRoutesList.includes(location.pathname)) {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    }
});

Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: `platform-spa@${__VERSION__ || __COMMIT_HASH__}`,
    integrations: [new BrowserTracing()],
});

gaTrackerInitialize();

ReactDOM.render(<PlatformApp history={history} store={store} />, document.querySelector('.__react-component'));
